import { useState, useRef, useEffect } from 'react';
import { useNavigate, Link, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { SET_MODAL_STATUS, SET_MODAL_TYPE } from 'store/actions';
import { ClickAwayListener, Paper, Avatar, Box, ButtonBase, Popper, List, ListItemButton, ListItemText, Typography } from '@mui/material';
import MainCard from 'ui-component/cards/MainCard';
import HelpIcon from '@mui/icons-material/HelpOutlineRounded';
import Transitions from 'ui-component/extended/Transitions';
const HelpSectionSection = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState('');
    const anchorRef = useRef(null);
    const customization = useSelector((state) => state.customization);
    const authentication = useSelector((state) => state.authentication);
    let { hasSubscribed, companyValidated } = authentication;
    let showItem = false;
    if (hasSubscribed && companyValidated) {
        showItem = true;
    }
    const navigate = useNavigate();
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    const prevOpen = useRef(open);
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);

    const handleChange = (event) => {
        if (event?.target.value) setValue(event?.target.value);
    };
    const handlePageChange = (page) => {
        navigate(page);
        setOpen(false);
    };
    return (
        <>
            <Box
                sx={{
                    ml: 3,
                    mr: 2
                    // [theme.breakpoints.down('md')]: {
                    //     mr: 1,
                    //     ml: 1
                    // }
                }}
            >
                <ButtonBase disableRipple>
                    <Avatar
                        variant="rounded"
                        className="header-icon"
                        ref={anchorRef}
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        onClick={handleToggle}
                        color="inherit"
                    >
                        <HelpIcon sx={{ fontSize: '24px' }} />
                    </Avatar>
                </ButtonBase>
            </Box>
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                placement={'bottom-end'}
                className="dashboard-header-popper help-center-popper"
            >
                {({ TransitionProps }) => (
                    <Transitions in={open} {...TransitionProps}>
                        <ClickAwayListener onClickAway={handleClose}>
                            <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                                <List className="menu-list">
                                    {showItem && (
                                        <ListItemButton disableRipple>
                                            <a href="https://www.diolog.com.au/help/help-centre" target="_blank">
                                                <ListItemText>Help centre</ListItemText>
                                            </a>
                                        </ListItemButton>
                                    )}
                                    <ListItemButton
                                        disableRipple
                                        onClick={() => {
                                            handlePageChange('contact-us');
                                            dispatch({ type: SET_MODAL_STATUS, modalStatus: false });
                                        }}
                                    >
                                        <ListItemText>Contact diolog </ListItemText>
                                    </ListItemButton>
                                    {showItem && (
                                        <ListItemButton
                                            disableRipple
                                            onClick={() => {
                                                dispatch({ type: SET_MODAL_STATUS, modalStatus: true });
                                                dispatch({ type: SET_MODAL_TYPE, modalType: 'feedback' });
                                            }}
                                        >
                                            <ListItemText>Give feedback </ListItemText>
                                        </ListItemButton>
                                    )}
                                </List>
                            </MainCard>
                        </ClickAwayListener>
                    </Transitions>
                )}
            </Popper>
        </>
    );
};

export default HelpSectionSection;
